import React, { useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { useTranslation } from 'react-i18next';
import MoreIcon from '@material-ui/icons/ExpandMore';
import { useOrganizations, useProperties, useSettings, useFields } from 'hooks';
import { DashboardHelpers } from 'utils';
import { CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';

const PropertyPicker = ({ variant, unsetLabel, unsetButtonLabel }) => {
  const { properties, selectedProperty, setSelectedProperty, isFetchingProperties, fetchProperties } = useProperties();
  const { setSelectedField, fetchFields } = useFields();
  const { selectedOrganization } = useOrganizations();
  const { activeDashView } = useSettings();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isFetchingProperties && (!properties || properties?.length === 0)) {
      fetchProperties();
    }
  }, []);

  const getPropertyItems = (popupState) => {
    const propertyItems = [
      <MenuItem
        key="none"
        onClick={(e) => {
          popupState.close(e);
          DashboardHelpers.setDefaultTelemetryPeriodByActiveTab(activeDashView);
          setSelectedProperty(undefined);
          setSelectedField(undefined);
        }}
      >
        {t(unsetLabel)}
      </MenuItem>,
    ];

    _.forEach(properties, (property, propertyId) => {
      if (!selectedOrganization || property.organization_id === selectedOrganization.id) {
        propertyItems.push(
          <MenuItem
            key={propertyId}
            onClick={(e) => {
              popupState.close(e);
              DashboardHelpers.setDefaultTelemetryPeriodByActiveTab(activeDashView);
              setSelectedProperty(property.id);
              fetchFields(property.id);
              setSelectedField({ id: DashboardHelpers.StatusCodes.NoFieldSelected, name: t('none_selected') });
            }}
          >
            {property.name}
          </MenuItem>
        );
      }
    });
    return propertyItems;
  };

  if (isFetchingProperties) {
    return <CircularProgress sx={{ color: grey[600] }} size={20} />;
  }

  return (
    <PopupState variant="popover" popupId="property-popup-menu">
      {(popupState) => (
        <>
          <Button {...bindTrigger(popupState)}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant={variant}>
                {selectedProperty ? selectedProperty.name : t(unsetButtonLabel)}
              </Typography>
              <MoreIcon fontSize="small" color="secondary" style={{ marginLeft: 4, marginTop: 4 }} />
            </div>
          </Button>
          <Menu {...bindMenu(popupState)}>{getPropertyItems(popupState)}</Menu>
        </>
      )}
    </PopupState>
  );
};
PropertyPicker.propTypes = {
  variant: PropTypes.string,
  unsetButtonLabel: PropTypes.string,
  unsetLabel: PropTypes.string,
  showDefault: PropTypes.bool, // if there is only one property, show the label or no-op
};
PropertyPicker.defaultProps = {
  variant: 'subtitle1',
  unsetButtonLabel: 'property_choose',
  unsetLabel: 'none',
  showDefault: false,
};
export default PropertyPicker;
